import React, { FC } from 'react'
import classNames from 'classnames'
import Skeleton from 'components/SA/Skeleton'
import styles from './components/SearchComponents.module.scss'

const SearchMenuContentSkeleton: FC = () => (
  <>
    <div className={styles.searchOptionsWrapper}>
      <div className={styles.searchOptionsContainerWithPadding}>
        <Skeleton width='120px' height='14px' />
      </div>
      <div className={classNames(styles.searchOptionsContainer, styles.searchOptionsContainerWithPadding)}>
        <Skeleton width='75%' height='16px' />
        <Skeleton width='55%' height='16px' />
        <Skeleton width='65%' height='16px' />
      </div>
    </div>
    <div className={styles.popularSearchesWrapper}>
      <Skeleton width='120px' height='14px' />
      <div className={styles.popularSearchesContainer}>
        <Skeleton width='80px' height='36px' className={styles.skeletonPill} />
        <Skeleton width='100px' height='36px' className={styles.skeletonPill} />
        <Skeleton width='70px' height='36px' className={styles.skeletonPill} />
        <Skeleton width='90px' height='36px' className={styles.skeletonPill} />
        <Skeleton width='80px' height='36px' className={styles.skeletonPill} />
      </div>
    </div>
  </>
)

export default SearchMenuContentSkeleton
